const dividerSize = Object.freeze({
	xs: 'var(--border-width-xs)',
	s: 'var(--border-width-s)',
	m: 'var(--border-width-m)',
	l: 'var(--border-width-l)',
	xl: 'var(--border-width-xl)',
});

export default dividerSize;
